import {
  useEffect,
  useRef,
} from 'react';
import { isMobile } from './mobile';

// marks the history entry an open note sits on, so a reload that lands on
// it doesn't stack another one
const ENTRY = 'noteOpen';

const onEntry = () => Boolean(history.state?.[ENTRY]);

// On a phone an open note hides the list, so it gets a history entry of its
// own: the back gesture, or the system back button, closes the note and
// shows the list rather than leaving the app. Closing it any other way takes
// the entry back off.
export const useBackToList = (open: boolean, close: () => void) => {
  const pushed = useRef(false);
  const closeRef = useRef(close);
  closeRef.current = close;

  useEffect(() => {
    if (open && !pushed.current && isMobile()) {
      if (!onEntry()) history.pushState({ [ENTRY]: true }, '');
      pushed.current = true;
    } else if (!open && pushed.current) {
      // cleared first, so the popstate this causes is ignored
      pushed.current = false;
      if (onEntry()) history.back();
    }
  }, [open]);

  useEffect(() => {
    const onPop = () => {
      if (!pushed.current) return;
      pushed.current = false;
      closeRef.current();
    };
    addEventListener('popstate', onPop);
    return () => removeEventListener('popstate', onPop);
  }, []);
};
